import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};